import { HOST, PROTOCOL, APP_LANGUAGE, LANGUAGE } from '../index';

const lang = APP_LANGUAGE !== 'cn' ? APP_LANGUAGE : LANGUAGE;

export const URL = `${ PROTOCOL }//${ HOST }`

/**
 * @name ID_TOKEN
 * @constant
 * @string
 * @description 
 */
export const ID_TOKEN = '{id}';

/**
 * @name CATEGORY_TOKEN
 * @constant
 * @string
 * @description 
 */
export const CATEGORY_TOKEN = '{categoryId}';

/**
 * @name CATEGORY_TYPE
 * @constant
 * @string
 * @description 
 */
 export const CATEGORY_TYPE = '{categoryType}';

/**
 * @name BASE_API
 * @constant
 * @string
 * @description Base URL for APIs
 */
export const BASE_API = `${ URL }/cdp/pst2`;

/**
 * @name BASE_SERVICE
 * @constant
 * @string
 * @description Base URL for Services
 */
export const BASE_SERVICE = `${ URL }/${ APP_LANGUAGE }/parametricsearch`;

/**
 * @name PARTS
 * @constant
 * @string
 * @description API for retrieving parts
 */
export const PARTS = BASE_API + `/data/${CATEGORY_TYPE}/${ CATEGORY_TOKEN }.js`;

/**
 * @name CONFIG
 * @constant
 * @string
 * @description API for retrieving PST configurations
 */
export const CONFIG = BASE_API + `/view/${ lang }/${ ID_TOKEN }.js`;

/**
 * @name PARAMETERS
 * @constant
 * @string
 * @description API for retrieving the PST parameters
 */
export const PARAMETERS = BASE_API + '/parametermapping.js';

/**
 * @name EXCEL
 * @constant
 * @string
 * @description Services for creating excel files
 */
export const EXCEL = BASE_SERVICE + `/PSTHandler/DownloadPstAsExcel`;

/**
 * @name QUICK_FILTER
 * @constant
 * @string
 * @description Services for retrieving quick filters
 */
export const QUICK_FILTER = BASE_SERVICE + `/api/QuickFilter/?pstId=${ ID_TOKEN }&type=pst`;

export const STATUS = {
    '5xx': `${ URL }/error/errorpage500.aspx`,
    '4xx': `${ URL }/error/errorpage404.aspx`
};

/**
 * @name PROMO_BANNER
 * @constant
 * @string
 * @description Services for retrieving quick filters
 */
 export const PROMO_BANNER = `${ URL }/cdp/adicommon2/${ lang }/PSTPromobanner.json`;

 /**
  * @name VERSION_CONTROL
  * @constant
  * @string
  * @description API for retrieving the version control information for the PST
  */
 export const VERSION_CONTROL = `${ URL }/cdp/pst2/versioninfo/${ ID_TOKEN }.js`;